import { Flex, Link, Text } from '@/ui';
import { useVisitorContext } from '../contexts/VisitorContext/useVisitorContext';

export const AuthorNotice = () => {
  const { isCollaboratorView, setIsCollaboratorView } = useVisitorContext();

  const enterAuthorMode = () => {
    setIsCollaboratorView(true);
  };

  if (isCollaboratorView) {
    return null;
  }

  return (
    <Flex align="center" gap="1" m="auto">
      <Text display={{ base: 'none', md: 'inline' }} fontWeight="medium">
        You&apos;re a manager of this page!
      </Text>
      <Link
        colorScheme="dark"
        fontWeight="medium"
        textDecor="underline"
        onClick={enterAuthorMode}
      >
        Edit
      </Link>
    </Flex>
  );
};
